/************
 Swipers
 ************/

// thumbnails mobile
let productV19ThumbnailImages = new Swiper("#productV19ThumbnailsSwiper", {
    slidesPerView: "auto",
    spaceBetween: 5,
    breakpoints: {
        800: {
            slidesPerView: 6,
        }
    },
    loop: true,
    navigation: {
        nextEl: '#productV19ThumbnailsNext',
        prevEl: '#productV19ThumbnailsPrev',
    },
});

// play video in the currently active slide (videos are muted + loop, so we never pause)
function playActiveSlideVideoV19(swiper) {
    const activeSlide = swiper.slides[swiper.activeIndex];
    const video = activeSlide?.querySelector("video");
    if (!video) {
        return;
    }
    video.play();
}

// main swiper
let productV19Images = new Swiper("#productV19Swiper", {
    navigation: {
        nextEl: '#productV19Swiper .productV19SwiperNext',
        prevEl: '#productV19Swiper .productV19SwiperPrev',
    },
    loop: true,
    thumbs: {
        swiper: productV19ThumbnailImages
    },
    on: {
        init: function () {
            playActiveSlideVideoV19(this);
        },
        slideChange: function () {
            playActiveSlideVideoV19(this);
        }
    }
});

// gallery desktop
document.querySelectorAll(".productV19GalleryItem").forEach(function (element) {
    element.addEventListener("click", function () {
        // determine index
        let index = getElIndex(this);

        // change active slide
        productV19Images.slideTo(index);
    });
});

/********************
 Video Popup
 *******************/

// open video
document.querySelectorAll('.productV19Video')?.forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        const popup = document.querySelector(".videoPopup");
        popup.showModal();

        // check if we're on mobile and if .videoPopupVideo.mobileOnly exists
        if (window.innerWidth < 800 && popup.querySelector(".videoPopupVideo.mobileOnly")) {
            popup.querySelector(".videoPopupVideo.mobileOnly").play();
        } else {
            popup.querySelector("video").play();
        }
    })
})


/*****************
 Reviews
 ****************/

document.querySelector("#productV19Review")?.addEventListener("click", function () {
    window.scrollTo({
        top: document.querySelector("#looxReviews").offsetTop - 100,
        behavior: "smooth"
    });
})


/**************
 Function To Update Pricing
 ***************/

// upcoming restock date for an oversold active variant, sent as the Ships line item property
let shipsDateObj = null;

// update active variant
function updateProductV16(skipImage = false) {

    // check for an active color swatch
    activeVariant = product.variants.filter((variant) => {
        return variant.id === parseInt(document.querySelector(".productV19FormGroupFlexColor:checked").value)
    })[0];

    // find variant image — match by filename since product.media slide ids no longer line up with variant.featured_image.id
    if (!skipImage) {
        if (activeVariant.featured_image) {
            const variantFilename = activeVariant.featured_image.src.split("/").pop().split("?")[0];
            const variantImage = Array.from(document.querySelectorAll(".productV19SwiperSlide")).find(slide => {
                const img = slide.querySelector("img");
                return img && img.src.split("/").pop().split("?")[0] === variantFilename;
            });
            if (variantImage) {
                productV19Images.slideTo(getElIndex(variantImage));
            }
        }
    }

    // determine the active variant's stock state from the checked swatch
    let isAvailable = activeVariant.available;
    let isPreOrder = false;
    let restockDateObj = null;

    const checkedColor = document.querySelector('.productV19FormGroupFlexColor:checked');
    if (checkedColor) {
        // a "sell when out of stock" variant stays available at 0 inventory, so treat that as pre order
        // (inventory_quantity / inventory_management aren't in the product JSON, so read them off the swatch)
        const managed = Boolean(checkedColor.dataset.inventoryManaged);
        const inventoryQuantity = parseInt(checkedColor.dataset.inventoryQuantity || '0', 10);
        isPreOrder = isAvailable && managed && inventoryQuantity <= 0;

        // build the restock date from its parts so "2026-07-01" stays a local date (UTC would shift the day)
        const restockDate = JSON.parse(checkedColor.dataset.restock || 'null');
        if (restockDate) {
            const [year, month, day] = restockDate.split('-').map(Number);
            restockDateObj = new Date(year, month - 1, day);
        }
    }

    // only an out of stock variant with a restock date that hasn't passed carries the Ships property
    shipsDateObj = null;
    if (isPreOrder && restockDateObj && new Date() < restockDateObj) {
        shipsDateObj = restockDateObj;
    }

    // update the shipping bar and buy button for the stock state
    const shipping = document.querySelector("#productV19Shipping");
    const shippingDateTxt = document.querySelector("#productV19ShippingDateTxt");
    const atc = document.querySelector("#productV19ATC");

    if (!isAvailable) {
        // sold out: 0 inventory and not sold when out of stock, so collect emails via the notify popup
        shipping.classList.add("oos");
        shippingDateTxt.innerHTML = `<strong>Out of Stock</strong>`;
        atc.classList.add("oos");
        atc.textContent = "Sold Out - Notify Me When Available";
    } else if (isPreOrder) {
        // pre order: still adds to cart normally, the restock date just replaces the ship date
        shipping.classList.remove("oos");
        if (restockDateObj) {
            const restockText = restockDateObj.toLocaleDateString('en-US', {month: 'short', day: 'numeric', year: 'numeric'});
            shippingDateTxt.innerHTML = `Ships <strong>${restockText}</strong>`;
        } else {
            shippingDateTxt.innerHTML = `<strong>Ships Soon</strong>`;
        }
        atc.classList.remove("oos");
        atc.textContent = "Pre Order";
    } else {
        // in stock: ships tomorrow and adds to cart normally
        shipping.classList.remove("oos");
        shippingDateTxt.innerHTML = `In Stock - Ships <strong>Tomorrow</strong>`;
        atc.classList.remove("oos");
        atc.textContent = `Add To Cart`;
    }
}

// format a date like "Oct 8th" for the Ships line item property
function formatShipsDate(date) {
    const day = date.getDate();

    // 11th, 12th and 13th break the st/nd/rd pattern
    let suffix = "th";
    if (day % 100 < 11 || day % 100 > 13) {
        suffix = {1: "st", 2: "nd", 3: "rd"}[day % 10] || "th";
    }

    return `${date.toLocaleDateString("en-US", {month: "short"})} ${day}${suffix}`;
}

updateProductV16(true)

/*******************
 Product Form (Default and Group)
 ********************/

// color swatch support on change
document.querySelectorAll(".productV19FormGroupFlexColor").forEach(function (element) {
    element.addEventListener("change", function () {
        // update label
        this.parentElement.parentElement.parentElement.querySelector(".productV19FormGroupHeaderLabel").innerHTML = this.getAttribute("aria-label");

        // update price
        updateProductV16();
    });
});


// variant dropdown support on change
document.querySelector("#productV19FormVariants")?.addEventListener("change", updateProductV16);


/****************
 *  Quantity
 *************/

let quantity = 1;


/**************
 Product ATC
 ***************/

// add to cart button
document.querySelector("#productV19ATC").addEventListener("click", async function (e) {
    e.preventDefault();

    // check for out of stock
    if (this.classList.contains("oos")) {
        // check email
        let {value: email} = await Swal.fire({
            title: product.title,
            text: "Enter your email to be notified when this product is back in stock.",
            input: "email",
            inputPlaceholder: "Email Address",
            confirmButtonText: "Notify Me When Available",
        });

        // confirm email is returned
        if (!email) {
            return;
        }

        // add to waitlist
        let formData = new FormData();
        formData.append("a", await klaviyo.account());
        formData.append("email", email);
        formData.append("g", "");
        formData.append("variant", activeVariant.id);
        formData.append("product", product.id);
        formData.append("platform", "shopify");
        formData.append("subscribe_for_newsletter", false);
        fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
            method: "POST",
            body: formData
        })

        // show success message
        await Swal.fire({
            title: "Success!",
            text: "You will be notified when this product is back in stock.",
            confirmButtonText: "OK",
        });

        return;
    }

    // add loading animation
    this.classList.add("loading");

    // create form data
    let formData = {
        items: []
    };


    // normal product
    const lineItem = {
        quantity: quantity,
        id: activeVariant.id,
    };

    // oversold variants with an upcoming restock carry the ship date through to the cart and checkout
    if (shipsDateObj) {
        lineItem.properties = {
            Ships: formatShipsDate(shipsDateObj)
        };
    }
    formData.items.push(lineItem);


    // reverse form data
    formData.items.reverse();

    // check if we should go directly to checkout
    if (this.classList.contains('checkout')) {

        // clear cart
        await clearCart();

        // add gift free gift
        // formData.items.push(
        //     {
        //         quantity: 1,
        //         id: 49838321369368
        //     }
        // )
        await addProduct(formData)

        window.location.href = '/checkout';

        // klaviyo tracking
        try {
            _learnq.push(['track', 'Added to Cart', item]);
        } catch (error) {
            console.error("Klaviyo tracking not found");
        }

        return;
    }

    // add productV19
    await addProduct(formData);

    // klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }

    // remove loading animation
    this.classList.remove("loading");

    // open cart
    await openCart();
});


// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // click normal atc
        document.querySelector("#productV19ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});

// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart_addon"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // check the addon if not already checked
        if (!document.querySelector("#productV19AddonCheckboxInput").checked) {
            document.querySelector("#productV19AddonCheckbox").click();
        }


        // click normal atc
        document.querySelector("#productV19ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});

/**************
 Sticky ATC
 ***************/

const stickyAtcObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
        if (entry.isIntersecting) {
            document.querySelector("#productV19ATC").classList.remove("sticky");
        } else {
            document.querySelector("#productV19ATC").classList.add("sticky");
        }
    });
}, {
    rootMargin: "-100px 0px 0px 0px"
})

// the sticky bar (sticky_bar setting) replaces the old fixed button
if (!document.querySelector("#productV19ATC").classList.contains("noSticky")) {
    stickyAtcObserver.observe(document.querySelector("#productV19Content"));
}

// event listeners for dropdown items
document.querySelectorAll(`.productV19DropdownTop`).forEach(function (element) {
    element.addEventListener("click", function () {
        this.parentElement.classList.toggle("active");
    });
});

/**************
 Sticky Add to Cart bar (sticky_bar setting)
 Shows while the main Add to Cart is off screen (above or below); its button clicks the real one.
 ***************/

(function () {
    const bar = document.querySelector("#productV19Sticky");
    const atc = document.querySelector("#productV19ATC");
    if (!bar || !atc) {
        return;
    }
    const barATC = bar.querySelector("#productV19StickyATC");
    const compare = document.querySelector("#productV19PriceCompare");
    const actual = document.querySelector("#productV19PriceActual");

    // mirror the real button, prices and the selected colour into the bar
    function sync() {
        barATC.textContent = atc.textContent.trim();
        barATC.classList.toggle("oos", atc.classList.contains("oos"));
        barATC.classList.toggle("loading", atc.classList.contains("loading"));
        barATC.disabled = atc.disabled;
        bar.querySelector("#productV19StickyProductInfoPriceCompare").textContent = compare ? compare.textContent.trim() : "";
        bar.querySelector("#productV19StickyProductInfoPriceActual").textContent = actual ? actual.textContent.trim() : "";
        if (typeof activeVariant !== "undefined" && activeVariant) {
            if (activeVariant.featured_image && activeVariant.featured_image.src) {
                bar.querySelector("#productV19StickyProductImage").src = activeVariant.featured_image.src;
            }
            bar.querySelectorAll(".productV19StickyProductInfoSwatchesItem").forEach(function (el) {
                el.classList.toggle("active", parseInt(el.dataset.variantId) === activeVariant.id);
            });
        }
    }

    // colour swatches go through the page's own colour radios, so price, images and stock stay in one place
    bar.addEventListener("click", function (e) {
        const swatch = e.target.closest(".productV19StickyProductInfoSwatchesItem");
        if (!swatch) {
            return;
        }
        const radio = document.querySelector(`.productV19FormGroupFlexColor[value="${swatch.dataset.variantId}"]`);
        if (!radio) {
            return;
        }
        radio.checked = true;
        radio.dispatchEvent(new Event("change"));
    });

    barATC.addEventListener("click", function () {
        atc.click();
    });

    // keep the bar in step with the page
    new MutationObserver(sync).observe(atc, {attributes: true, childList: true, characterData: true, subtree: true});
    [compare, actual].forEach(function (el) {
        if (el) {
            new MutationObserver(sync).observe(el, {childList: true, characterData: true, subtree: true});
        }
    });
    document.addEventListener("change", function (e) {
        if (e.target.closest && e.target.closest(".productV19FormGroupFlexColor, #productV19FormVariants")) {
            sync();
        }
    });

    // show the bar whenever the main button is off screen; the 80px inset stops edge flicker
    function setVisible(atcInView) {
        bar.classList.toggle("active", !atcInView);
        bar.setAttribute("aria-hidden", atcInView ? "true" : "false");
    }
    new IntersectionObserver(function (entries) {
        setVisible(entries[0].isIntersecting);
    }, {threshold: 0, rootMargin: "0px 0px -80px 0px"}).observe(atc);

    // also check on load and scroll, for the first paint while images and CSS are still settling
    let checkQueued = false;
    function check() {
        checkQueued = false;
        const rect = atc.getBoundingClientRect();
        setVisible(rect.bottom > 0 && rect.top < window.innerHeight - 80);
    }
    function queueCheck() {
        if (!checkQueued) {
            checkQueued = true;
            window.requestAnimationFrame(check);
        }
    }
    window.addEventListener("scroll", queueCheck, {passive: true});
    window.addEventListener("resize", queueCheck);
    window.addEventListener("load", check);
    check();

    sync();
}());
